import React from 'react';
import ChatsWhatsappPage from './ChatsWhatsappPage';

const ChatsColetaPage = (props) => <ChatsWhatsappPage {...props} chatTipo="coleta" />;

export default ChatsColetaPage;
